import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { EMPTY, Observable, throwError } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { StoreStateService, USER_AUTHENTICATION_SERVICE, UserAuthInterface } from '../services';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
// import { SignalRNotificationService } from '../services/signalr.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private isHandlingUnauthorized = false;

  constructor(
    private _router: Router,
    @Inject(USER_AUTHENTICATION_SERVICE) private _userAuthInterface: UserAuthInterface,
    // private _signalRService: SignalRNotificationService,
    private _storeState: StoreStateService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentUser = this._userAuthInterface.authenticatedUser;
    if (currentUser?.token) {
      request = request.clone({ setHeaders: { Authorization: `Bearer ${currentUser.token}` } });
    }

    const isLogoutCall = request.url.includes('logout');

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !isLogoutCall) {
          if (!this.isHandlingUnauthorized) {
            this.isHandlingUnauthorized = true;
            // this._signalRService.stopConnection();
            this._userAuthInterface.clearSession();
            this._storeState.clearStore();
            this._router.navigate(['/account/login']).finally(() => {
              this.isHandlingUnauthorized = false;
            });
          }
          return EMPTY;
        }
        return throwError(() => error);
      })
    );
  }
}


